export default "__VITE_ASSET__fac7059e__"